import { AApi } from './AApi';
import type { ApiDeletedBody, ApiResult, PaginationBody, PaginationParams } from '../types/api.types';
import type { SessionBody } from '../types/sessions.types';

/** The Sessions module: the open sessions and their cleanup — the own session is ended by logging out, not here. */
export class SessionsApi extends AApi {
    /** DELETE /sessions/{uuid} — 409 (`SESSION.own`) for the own one. */
    public deleteSession(sessionUuid: string): Promise<ApiResult<undefined>> {
        return this.Client.delete(`${this.VersionPath}/sessions/${encodeURIComponent(sessionUuid)}`);
    }

    /** DELETE — every session not used for `days` days (`updated_at`). */
    public deleteSessionsOlderThan(days: number): Promise<ApiResult<ApiDeletedBody>> {
        return this.Client.delete(`${this.VersionPath}/sessions/olderThan/${Math.max(1, Math.round(days)).toString()}`);
    }

    /** DELETE — every session without a logged-in user. */
    public deleteSessionsWithoutUser(): Promise<ApiResult<ApiDeletedBody>> {
        return this.Client.delete(`${this.VersionPath}/sessions/withoutUser`);
    }

    /** GET — the sessions not expired yet, the most recently used first. */
    public listSessions(params?: PaginationParams): Promise<ApiResult<{ sessions: SessionBody[]; pagination?: PaginationBody }>> {
        return this.Client.get(`${this.VersionPath}/sessions${this.toQuery(params)}`);
    }
}
